export var ListPageType;
(function (ListPageType) {
    ListPageType["SEARCH"] = "search";
    ListPageType["STUDY"] = "study";
    ListPageType["ARTICLE"] = "article";
    ListPageType["ARTICLE_OVERVIEW"] = "article_overview";
    ListPageType["STUDY_OPTIONS"] = "study_options";
    ListPageType["UNIVERSITY"] = "university";
    ListPageType["ACCOUNT"] = "account";
    ListPageType["COUNTRY"] = "country";
    ListPageType["COUNTRY_DEGREE"] = "country_degree";
    ListPageType["DISCIPLINE"] = "discipline";
    ListPageType["CITY"] = "city";
    ListPageType["UNIBUDDY"] = "unibuddy";
    ListPageType["HOME"] = "home";
    ListPageType["META_RANKING"] = "meta_ranking";
    ListPageType["SCHOLARSHIP"] = "scholarship";
    ListPageType["SCHOLARSHIP_OVERVIEW"] = "scholarship_overview";
    ListPageType["PERSONALITY_TEST"] = "personality_test";
    ListPageType["RANKINGS"] = "rankings";
    ListPageType["RANKINGS_REVIEWS"] = "rankings_reviews";
    ListPageType["COUNTRY_TEST"] = "country_test";
    ListPageType["VISA_INFO"] = "visa_info";
    ListPageType["UNIVERSITIES_SCHOLARSHIPS"] = "universities_scholarships";
    ListPageType["UNIVERSITY_RANKINGS"] = "university_rankings";
})(ListPageType || (ListPageType = {}));
